/**
 * 数据字典下拉框
 * 2019-04-28 chenxiaojian
 */
import React from 'react';
import { Slider, Row, Col,Input} from 'antd';



class DictSlider extends React.Component {

    state = {
        dictList: [],
        inputValue:1
    }

    componentDidMount() {
        if(this.props.onRef){
            this.props.onRef(this)
        }
    }



    onChange = value => {
        if (isNaN(value)) {
          return;
        }
        this.setState({
          inputValue: value,
        });
        this.props.changeSlider(value)
    };

    render() {
        return  <Row>
                    <Col span={16}>
                        <Slider  min={0}  max={1} step={0.1}  onChange={this.onChange} value={typeof this.state.inputValue === 'number' ? this.props.value : 0} />
                    </Col>
                    <Col span={4}><Input style={{ marginLeft: 16 }} value={this.props.value} onChange={this.onChange} disabled={true} /></Col>
                </Row>  
    };
}

export default DictSlider;